import { SalesInvoiceListPage } from "@/features/sales-invoice/pages/SalesInvoiceListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-invoice/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["sales_invoice.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesInvoiceListPage,
});
